import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "mmi-probing",
  "aria-hidden": "true"
}
const _hoisted_2 = { key: 2 }
const _hoisted_3 = { class: "row justify-content-center" }
const _hoisted_4 = { class: "col-12 col-xl-10 col-xxl-8" }
const _hoisted_5 = { class: "ratio ratio-16x9" }
const _hoisted_6 = ["src"]
const _hoisted_7 = { class: "col-12 col-xl-10 col-xxl-8 mt-3" }
const _hoisted_8 = { class: "card mmi-teaser-card" }
const _hoisted_9 = { class: "card-body justify-content-center align-items-center d-flex flex-column text-center overflow-hidden" }
const _hoisted_10 = ["src"]
const _hoisted_11 = {
  key: 3,
  class: "d-flex flex-column"
}
const _hoisted_12 = { class: "row border-bottom pb-2" }
const _hoisted_13 = { class: "col-12 col-sm-10 offset-sm-1 offset-lg-0 col-lg-6 offset-xl-1 col-xl-5" }
const _hoisted_14 = { class: "row flex-column pb-3" }
const _hoisted_15 = { class: "d-flex mb-2" }
const _hoisted_16 = { class: "btn-group btn-group-sm me-2" }
const _hoisted_17 = ["disabled"]
const _hoisted_18 = ["disabled"]
const _hoisted_19 = ["disabled"]
const _hoisted_20 = { class: "input-group input-group-sm" }
const _hoisted_21 = ["disabled"]
const _hoisted_22 = { key: 0 }
const _hoisted_23 = { class: "row text-center" }
const _hoisted_24 = {
  key: 0,
  class: "col-10 offset-1 mt-3"
}
const _hoisted_25 = {
  key: 1,
  class: "col-10 offset-1 mt-3"
}
const _hoisted_26 = { class: "mt-2" }
const _hoisted_27 = { class: "text-center fw-bold" }
const _hoisted_28 = { class: "col-12 col-sm-10 offset-sm-1 offset-lg-0 col-lg-6 col-xl-5" }
const _hoisted_29 = { class: "ratio ratio-16x9" }
const _hoisted_30 = ["src"]
const _hoisted_31 = { class: "row border-bottom pb-2" }
const _hoisted_32 = ["onClick"]
const _hoisted_33 = { class: "col-12 mt-2" }
const _hoisted_34 = { key: 1 }
const _hoisted_35 = { class: "row cards-container d-flex flex-wrap pt-3 mx-auto" }
const _hoisted_36 = {
  key: 0,
  class: "breakr-2"
}
const _hoisted_37 = {
  key: 1,
  class: "breakr-3"
}
const _hoisted_38 = {
  key: 2,
  class: "breakr-5"
}
const _hoisted_39 = { class: "mmi-user-card px-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_mmi_structure_skeleton = _resolveComponent("mmi-structure-skeleton")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_user_not_found = _resolveComponent("user-not-found")!
  const _component_searching = _resolveComponent("searching")!
  const _component_mmi_current_user_card = _resolveComponent("mmi-current-user-card")!
  const _component_class_modal = _resolveComponent("class-modal")!
  const _component_videos_playlist = _resolveComponent("videos-playlist")!
  const _component_register = _resolveComponent("register")!
  const _component_mmi_user_card = _resolveComponent("mmi-user-card")!

  return (_ctx.membership === 'unknown')
    ? (_openBlock(), _createElementBlock("div", _hoisted_1))
    : (_ctx.loading)
      ? (_openBlock(), _createBlock(_component_mmi_structure_skeleton, { key: 1 }))
      : (!_ctx.isActive)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("iframe", {
                    src: _ctx.SubscriptionConfig?.videos?.stop,
                    width: "640",
                    height: "360",
                    frameborder: "0",
                    allow: "autoplay; fullscreen; picture-in-picture",
                    allowfullscreen: ""
                  }, null, 8, _hoisted_6)
                ])
              ]),
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _cache[8] || (_cache[8] = _createElementVNode("h6", { class: "card-header text-nowrap d-flex align-items-center" }, [
                    _createElementVNode("span", null, "Acelerador de Riqueza")
                  ], -1)),
                  _createElementVNode("div", _hoisted_9, [
                    _createElementVNode("img", {
                      class: "mmi-teaser-emoji mb-2",
                      src: require('../../assets/img/emoji/astonished-face.svg'),
                      alt: "😲"
                    }, null, 8, _hoisted_10),
                    _cache[6] || (_cache[6] = _createElementVNode("div", { class: "mmi-teaser-headline mb-2" }, " ¿Cómo que no cuentas con este producto? ", -1)),
                    _cache[7] || (_cache[7] = _createElementVNode("div", { class: "small mb-3" }, " Es de lo más pedido de la Academia — no te quedes viendo desde afuera. ", -1)),
                    _createElementVNode("div", null, [
                      _createVNode(_component_router_link, {
                        to: "/subscriptions",
                        class: "btn btn-primary"
                      }, {
                        default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
                          _createTextVNode(" Ver Suscripciones ", -1)
                        ]))]),
                        _: 1
                      })
                    ])
                  ])
                ])
              ])
            ])
          ]))
        : (_ctx.isActive)
          ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("div", _hoisted_13, [
                  _createElementVNode("div", _hoisted_14, [
                    _createElementVNode("div", _hoisted_15, [
                      _createElementVNode("div", _hoisted_16, [
                        _createElementVNode("button", {
                          class: "btn btn-outline-secondary",
                          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.goUp())),
                          disabled: _ctx.isRootNode
                        }, [...(_cache[9] || (_cache[9] = [
                          _createElementVNode("i", { class: "fas fa-chevron-up fa-fw" }, null, -1)
                        ]))], 8, _hoisted_17),
                        _createElementVNode("button", {
                          class: "btn btn-outline-secondary",
                          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.goRoot())),
                          disabled: _ctx.isRootNode && !_ctx.userNotFound
                        }, [...(_cache[10] || (_cache[10] = [
                          _createElementVNode("i", { class: "fas fa-angle-double-up fa-fw" }, null, -1)
                        ]))], 8, _hoisted_18)
                      ]),
                      _createElementVNode("button", {
                        class: "btn btn-outline-secondary btn-sm me-2",
                        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.refresh())),
                        disabled: _ctx.refreshing
                      }, [
                        _createElementVNode("i", {
                          class: _normalizeClass(["fas fa-redo fa-fw", { 'fa-spin': _ctx.refreshing }])
                        }, null, 2)
                      ], 8, _hoisted_19),
                      _createElementVNode("div", _hoisted_20, [
                        _withDirectives(_createElementVNode("input", {
                          type: "text",
                          class: "form-control",
                          placeholder: "Nombre de Usuario",
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.searchUsername) = $event))
                        }, null, 512), [
                          [
                            _vModelText,
                            _ctx.searchUsername,
                            void 0,
                            { trim: true }
                          ]
                        ]),
                        _createElementVNode("button", {
                          class: "btn btn-outline-secondary",
                          onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.searchUser && _ctx.searchUser(...args))),
                          disabled: _ctx.searchUsername == '' || _ctx.searching
                        }, [...(_cache[11] || (_cache[11] = [
                          _createElementVNode("i", { class: "fas fa-search fa-fw" }, null, -1)
                        ]))], 8, _hoisted_21)
                      ])
                    ]),
                    (_ctx.searching || _ctx.userNotFound)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                          _createElementVNode("div", _hoisted_23, [
                            (_ctx.userNotFound)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                                  _createVNode(_component_user_not_found)
                                ]))
                              : _createCommentVNode("", true),
                            (_ctx.searching)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                                  _createVNode(_component_searching)
                                ]))
                              : _createCommentVNode("", true)
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.displayUser)
                      ? (_openBlock(), _createBlock(_component_mmi_current_user_card, {
                          key: 1,
                          "user-data": _ctx.currentStructure
                        }, null, 8, ["user-data"]))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", _hoisted_26, [
                    _createElementVNode("h5", _hoisted_27, _toDisplayString(_ctx.currentVideo.title), 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_28, [
                  _createElementVNode("div", _hoisted_29, [
                    _createElementVNode("iframe", {
                      src: _ctx.currentVideo.url,
                      width: "640",
                      height: "360",
                      frameborder: "0",
                      allow: "autoplay; fullscreen; picture-in-picture",
                      allowfullscreen: ""
                    }, null, 8, _hoisted_30)
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_31, [
                (_ctx.editPermision)
                  ? (_openBlock(), _createBlock(_component_class_modal, {
                      key: 0,
                      classId: "weekschedule-modal",
                      scheduleType: "mmiColombia"
                    }, {
                      button: _withCtx(({ onClick }) => [
                        _createElementVNode("button", {
                          type: "button",
                          class: "btn btn-info btn-sm text-light ms-auto mt-2 me-2",
                          style: {"max-width":"150px"},
                          onClick: onClick
                        }, [...(_cache[12] || (_cache[12] = [
                          _createElementVNode("i", { class: "fas fa-plus fa-fw me-1" }, null, -1),
                          _createTextVNode(" Nueva clase ", -1)
                        ]))], 8, _hoisted_32)
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_33, [
                  _createVNode(_component_videos_playlist, {
                    videos: _ctx.playlist,
                    "watched-videos": _ctx.watchedVideos,
                    onSelectedVideo: _ctx.changeVideo,
                    onWatchedVideo: _ctx.addWatchedVideo,
                    onUnwatchedVideo: _ctx.removeWatchedVideo
                  }, null, 8, ["videos", "watched-videos", "onSelectedVideo", "onWatchedVideo", "onUnwatchedVideo"])
                ])
              ]),
              false
                ? (_openBlock(), _createBlock(_component_register, {
                    key: 0,
                    chapter: _ctx.chapter
                  }, null, 8, ["chapter"]))
                : _createCommentVNode("", true),
              (_ctx.displayUser && _ctx.currentStructure?.users?.length > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                    _createElementVNode("div", _hoisted_35, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.currentStructure.users, (user, index) => {
                        return (_openBlock(), _createElementBlock(_Fragment, {
                          key: user.username
                        }, [
                          (index < 5)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                (index < 2 && index == _ctx.breakRowAt[2])
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_36))
                                  : _createCommentVNode("", true),
                                (index < 3 && index == _ctx.breakRowAt[3])
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_37))
                                  : _createCommentVNode("", true),
                                (index < 5 && index == _ctx.breakRowAt[5])
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_38))
                                  : _createCommentVNode("", true)
                              ], 64))
                            : _createCommentVNode("", true),
                          _createElementVNode("div", _hoisted_39, [
                            _createVNode(_component_mmi_user_card, { userData: user }, null, 8, ["userData"])
                          ])
                        ], 64))
                      }), 128))
                    ])
                  ]))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true)
}